
import { useState } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from "react-redux"
import { formatDinero } from "./../../../utils/formatDinero"
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
const columns = [
    { id: "cliente", minWidth: 50, align: "center", label: "Nombre del cliente" },
    { id: "paquete", minWidth: 50, align: "center", label: "Paquete" },
    { id: "np", minWidth: 50, align: "center", label: "Num Pax" },
    { id: "fechaSalida", minWidth: 50, align: "center", label: "Fecha de Salida" },
    { id: "motivo", minWidth: 50, align: "center", label: "Motivo" },
    { id: "montoAhorrado", minWidth: 50, align: "center", label: "Monto" },
    { id: "operador", minWidth: 50, align: "center", label: "Operador" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TItemUtilidad = () => {
    const Compras = useSelector(store => store.finanzas.ItemsUtilidad)
    const rows = Compras.compras ?? []
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.idCompra}>
                                        <TableCell align='center'>
                                            {`${row.meta?.Referencia}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row.paquete?.Nombre}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.paquete?.Numero_Personas}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row.paquete?.Fecha_Viaje, formato: "dd MMMM yyyy" })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.TipoCompra?.Descripcion}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.MontoCuenta)} ${row.paquete?.Cotizacion?.Moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.paquete?.Proveedor}`}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TItemUtilidad